import { Nilable } from "@shared/utils";
import { MensajeProcesador } from "../MensajeProcesador";

export class TimeoutProcesador implements MensajeProcesador {
    puedeProcesar(mensaje: string): boolean {
        return mensaje.includes("Timeout");
    }
    procesar(_mensaje: string): Nilable<string> {
        return "El tiempo de espera agotado. Intente nuevamente";
    }
}
